import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesToGb',
  standalone: true
})
export class BytesToGbPipe implements PipeTransform {

  transform(value: number, fractionDigits = 0): string {
    if (isNaN(value) || value < 0) {
      return '0 KB';
    }

    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;

    if (value < KB) {
      return `${value} Bytes`;
    } else if (value < MB) {
      return `${(value / KB).toFixed(fractionDigits)} KB`;
    } else if (value < GB) {
      return `${(value / MB).toFixed(fractionDigits)} MB`;
    } else {
      return `${(value / GB).toFixed(fractionDigits)} GB`;
    }
  }


}
